import { Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import ImpactsOnStakeholderOverviewIntroduction, {
  IMPACT_STAKEHOLDER_INTRODUCTION_ID,
} from './ImpactsOnStakeholderOverviewIntroduction';
import ImpactsOnStakeholderOverviewRemark, {
  IMPACT_STAKEHOLDER_REMARK_ID,
} from './ImpactsOnStakeholderOverviewRemark';

const ImpactsOnStakeholderOverview = () => {
  return (
    <Box p={2} bgcolor={'white'}>
      <Flex gap={1}>
        <Typography fontWeight={800}>
          การจัดการผลกระทบต่อผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ
        </Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <ImpactsOnStakeholderOverviewIntroduction />
          <ImpactsOnStakeholderOverviewRemark />
        </Flex>
      </Flex>
      <Box id={IMPACT_STAKEHOLDER_INTRODUCTION_ID} />
      <Box id={IMPACT_STAKEHOLDER_REMARK_ID} />
    </Box>
  );
};

export default ImpactsOnStakeholderOverview;
